import { parseHtml } from "@/utils/common";

interface Props {
  block: {
    Title: string;
    description: string;
  };
}
const UseCaseIntroduction: React.FC<Props> = ({ block }) => {
  return (
    <>
      <section className="pb-[36px] lg:pb-[46px] xl:pb-[56px] bg-white max-w-[1020px] mx-auto">
        <div className="container">
          <div className="use-case-new">
            <h2>{block.Title ?? ""}</h2>
            <p>{block.description ? parseHtml(block.description) : ""}</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default UseCaseIntroduction;
